module.exports = __webpack_public_path__ + "static/media/banner-pres-mobile-bg.06fa2ce3.bin";